module.exports = __webpack_public_path__ + "static/img/logo.5d4a5bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1